import(/* webpackMode: "eager", webpackExports: ["HomeContent"] */ "/vercel/path0/src/app/HomeContent.tsx");
